import React from 'react';

type ShareDeprecationNoticeProps = {
  linkToUrl?: string;
};

export function AppDeprecationNotice({
  linkToUrl,
}: ShareDeprecationNoticeProps): JSX.Element {
  const linkToContent = linkToUrl
    // Remove double slash in linkToUrl, but not after https://
    ?.replace(/(?<!:)\/\//g, '/')
    // Remove teams auth popup parameters
    ?.replace(/\?.*/, '');

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
      }}
    >
      <p>This app is no longer supported.</p>
      {linkToContent && (
        <p>
          The content remains available at{' '}
          <a href={linkToContent} target='_blank'>
            {linkToContent}
          </a>
          .
        </p>
      )}
      <p>This tab may be removed.</p>
    </div>
  );
}
